
const OtpDescription = ({ phone }) => {
    return (
        <span className="otpDescription">{
            `Таны ${phone} дугаарт очсон нэг удаагийн кодыг оруулна уу.`
        }</span>
    );
};

export default OtpDescription;